import { useEffect, useRef, useState } from 'react';

const CHECKINTERVAL = 3000;

export default function useLive(playbackUrl: string | null): boolean {
	const [isLive, setIsLive] = useState(false);
	const checkInterval = useRef<NodeJS.Timeout | undefined>();
	const abortController = useRef<AbortController | undefined>();

	useEffect(() => {

		//needed to cancel the request when playbackUrl changes
		abortController.current = new AbortController();
		const { signal } = abortController.current;

		//only if user has set a playback url
		if (playbackUrl) {
			//check the playbackUrl for a 404
			fetch(playbackUrl, { signal }).then(result => {
				//if the playback url has returned ok, channel is live
				setIsLive(result.ok);
			}).catch(e => {
				console.log(e);
			});

			checkInterval.current = setInterval(() => {
				//check the playbackUrl for a 404
				fetch(playbackUrl, { signal }).then(result => {
					//if the playback url has returned ok, channel is live
					setIsLive(result.ok);
				}).catch(e => {
					console.log(e);
				});
			}, CHECKINTERVAL);
		} else {
			setIsLive(false);
			abortController.current.abort();
			if (checkInterval.current) {
				clearInterval(checkInterval.current);
			}
		}

		() => {
			//cleanup listener
			if (checkInterval.current) {
				clearInterval(checkInterval.current);
				abortController.current?.abort();
			}
		};
	}, [playbackUrl]);

	useEffect(() => {
		return () => {
			if (checkInterval.current) {
				clearInterval(checkInterval.current);
				abortController.current?.abort();
			}
		};
	}, []);

	return isLive;
}